import React from 'react';
import {
    DialogTitle, Dialog, DialogContent, Container, Grid,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(() => ({
    dialogTitle: {
        fontFamily: 'Montserrat',
        fontSize: '1.895rem',
        fontWeight: 'bold',
        color: '#3E3E3C',
    },
    dialogSubtitle: {
        fontFamily: 'Montserrat',
        fontSize: '0.85rem',
        color: '#53546A',
    },
    closeIcon: {
        marginTop: '-3rem',
        marginLeft: '4rem',
        cursor: 'pointer',
    },
    modalDialog: {
        backgroundColor: 'rgba(13, 17, 94, 0.5)',
    },
    modalContent: {
        padding: '1.25rem',
        backgroundColor: '#F7F9FF',
        borderRadius: '0.625rem',
        textAlign: 'center',
    },
    modalWidth: {
        maxWidth: '51rem',
        width: '51rem',
    },
    lineH: {
        width: 33,
        height: 2,
        background: 'linear-gradient(90deg, #E02A58, #C00333)',
        opacity: 1,
        margin: 'auto',
        marginTop: 11,
        marginBottom: 11,
    },
}));

/**
 * Se genera un componente base para una modal.
 */
const BaseModal = ({
   open, onClose, children, modalProps, maxWidth, close,
   title, message,
                   }) => {
    const classes = useStyles();

    return (
      <Dialog
        {...modalProps}
        fullWidth
        open={open}
        onClose={onClose}
        keepMounted={false}
        maxWidth={maxWidth}
        aria-labelledby="form-dialog-title"
        disableBackdropClick
        classes={{
            root: classes.modalDialog,
            paper: classes.modalContent,
            paperWidthSm: classes.modalWidth,
        }}
      >
        {title !== null ? (
          <DialogTitle>
            <Grid container>
              <Grid item xs={11} />
              {Boolean(close) && (
                <Grid item xs={1}>
                  <CloseIcon onClick={onClose} className={classes.closeIcon} />
                </Grid>
                )}
            </Grid>
            <h2 className={classes.dialogTitle}>{title}</h2>
            <hr className={classes.lineH} align="left" />
            <Grid item xs={12}>
              <Container maxWidth={maxWidth}>
                <p className={classes.dialogSubtitle}>
                  {message}
                </p>
              </Container>
            </Grid>
          </DialogTitle>
            ) : null }
        <DialogContent>
          {children}
        </DialogContent>
      </Dialog>
    );
};

BaseModal.defaultProps = {
    title: null,
    message: null,
    modalProps: null,
    styles: null,
    maxWidth: 'md',
    close: true,
};

BaseModal.propTypes = {
    // Vista a mostrar desde el padre
    children: PropTypes.node.isRequired,
    // Variable booleana para abrir la modal
    open: PropTypes.bool.isRequired,
    // Muestra o no el icono de cerrar
    close: PropTypes.bool,
    // Funcion que cierra la modal
    onClose: PropTypes.func.isRequired,
    // Titulo y mensaje de la modal
    title: PropTypes.string,
    message: PropTypes.string,
    // Props no especificados
    modalProps: PropTypes.oneOfType([PropTypes.object]),
    // Objeto de estilos segun el padre
    styles: PropTypes.oneOfType([PropTypes.object]),
    // Tamaño de la modal. si no llega sera de MD su valor
    maxWidth: PropTypes.string,
};

export default BaseModal;
